import { observer } from 'mobx-react';
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Grid,
  Typography,
  Chip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Button } from '@roc/ui';
import { useEffect } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CheckCircle } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    margin: '10px',
    minWidth: '150px',
  },
  notAuthtenticatedButton: {
    margin: '10px',
    minWidth: '150px',
    backgroundColor: 'red',
    '&:hover': {
    backgroundColor: 'red',
  },
  },
}));

const divider = <Divider variant="middle" component="li" />;


export const LinkedInAuthCard = observer(() => {

const classes = useStyles();
const { salesforceLeadStore, ringCentralStore, userStore, whiteLabelStore, linkedInStore } = useStore();

  async function handleOnClick() {
  const host = await whiteLabelStore.getHostByPortaId(userStore.userInformation.portalId);
  linkedInStore.retriveTokenWithOAuthToken('Roc', host);
}

  return (
<Paper className={classes.paper} style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
  <Box display="flex" alignItems="center" mb={2}>
    <img
      src="https://static.vecteezy.com/system/resources/previews/018/930/587/original/linkedin-logo-linkedin-icon-transparent-free-png.png"
      alt="Logo"
      style={{ width: '80%', maxWidth: 100 }}
    />
    <Box flexGrow={1} ml={2}>
      <Typography variant="h6">
        {'LinkedIn Connection (Roc)'}
      </Typography>
    </Box>
  </Box>
  <Box display="flex" alignItems="center" mb={2}>
    <Box mr={2}>
    {
      userStore.userInformation.connectedWithLinkedInRoc ? (
        <Chip
         icon={<CheckCircle style={{
                    color: 'white'
                  }} />}
          label="CONNECTED"
          style={{
            backgroundColor: '#008f39',
            letterSpacing: 2,
            color: '#FFFFFF',
            fontWeight: 'bold'
          }}
        />
      ) : (
        <Chip
          label="NOT CONNECTED"
          style={{
            backgroundColor: '#b3b3b3',
            letterSpacing: 2,
            color: '#777',
            fontWeight: 'bold'
          }}
        />
      )
    }
    </Box>
    <Button
      className={classes.button}
      variant="contained"
      size="small"
      color="primary"
      testId="Authenticate_With_LinkedIn"
      onClick={handleOnClick}
    >
      Connect LinkedIn
    </Button>
  </Box>
</Paper>);
});
